export class AlfatronWu4k {
    constructor(socket) {
        this.socket = socket;
        this.autoSwitch = false;
        this.firmwareVersion = '1.00';
        this.usbSwitchMode = '0';
        this.videoMatrixRoutes = '1';
        this.asyncHandlers = [
            {
                name: 'autoSwitchQuery',
                regExp: /#GET_AUTO_SWITCH/i,
                callback: (match) => {
                    this.socket.send(`@HDMI OUT SWITCH TO ${this.autoSwitch ? 'AUTO' : 'MANUAL'} MODE!`);
                },
            },
            {
                name: 'autoSwitchSet',
                regExp: /#SET_AUTO_SWITCH (0|1)/i,
                callback: (match) => {
                    this.autoSwitch = match[1] === '1';
                    this.socket.send(`@HDMI OUT SWITCH TO ${this.autoSwitch ? 'AUTO' : 'MANUAL'} MODE!`);
                },
            },
            {
                name: 'firmwareVersion',
                regExp: /#GET_FIRMWARE_VERSION/i,
                callback: (match) => {
                    this.socket.send(`@V${this.firmwareVersion}`);
                },
            },
            {
                name: 'usbSwitchModeQuery',
                regExp: /#GET_USB_SWITCH_MODE/i,
                callback: (match) => {
                    this.socket.send(`@USB SWITCH MODE TO ${this.usbSwitchMode}!`);
                },
            },
            {
                name: 'usbSwitchModeSet',
                regExp: /#SET_USB_SWITCH_MODE (0|1)/i,
                callback: (match) => {
                    this.usbSwitchMode = match[1];
                    this.socket.send(`@USB SWITCH MODE TO ${this.usbSwitchMode}!`);
                },
            },
            {
                name: 'videoMatrixRoutesQuery',
                regExp: /#GET_AV/i,
                callback: (match) => {
                    this.socket.send(`@HDMI IN SWITCH TO ${this.videoMatrixRoutes}!`);
                },
            },
            {
                name: 'videoMatrixRoutesSet',
                regExp: /#SET_AV H(.+)/i,
                callback: (match) => {
                    this.videoMatrixRoutes = match[1];
                    this.socket.send(`@HDMI IN SWITCH TO ${this.videoMatrixRoutes}!`);
                },
            },
        ];
    }
}
AlfatronWu4k.emulatorType = 'socketEmulator';
AlfatronWu4k.key = '-Mvi8cIZtoTru47rGviy';
